import React from 'react';
import { CustomDatePicker } from '@components';
import styles from '../Expense.module.scss';

export default function ExpenseFilters({
  canViewExpenseHistory,
  data,
  filters,
  onChange,
  onRefresh,
}) {
  const items = data.items.filter((item) =>
    data.filterExpenseIDs.some(
      ({ expenseID }) => expenseID === item.id,
    ),
  );
  return (
    <div className={styles.filterContainer}>
      <div className={styles.statistic}>
        <div className={styles.statisticContent}>
          <span className={styles.statisticLabel}>Số khoản chi:</span>
          <span className={styles.statisticValue}>{data.count}</span>
        </div>
        <div className={styles.statisticContent}>
          <span className={styles.statisticLabel}>Tổng chi:</span>
          <span className={styles.statisticValue}>
            {data.sum.toLocaleString('vi-VN', {
              style: 'currency',
              currency: 'VND',
            })}
          </span>
        </div>
      </div>
      <div className={styles.btnRefreshWrapper}>
        <button
          className={styles.btn}
          disabled={data.loading}
          onClick={onRefresh}
        >
          Refresh
        </button>
      </div>
      <select
        aria-label="Lọc khoản chi"
        className={styles.select}
        value={filters.expense}
        onChange={(e) => onChange({ expense: e.target.value })}
      >
        <option value="">Tất cả khoản chi</option>
        {items.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      {canViewExpenseHistory && (
        <CustomDatePicker
          startDate={new Date(filters.startDate)}
          endDate={new Date(filters.endDate)}
          setStartDate={(date) =>
            onChange({ startDate: date.getTime() })
          }
          setEndDate={(date) => onChange({ endDate: date.getTime() })}
        />
      )}
    </div>
  );
}
